import React from 'react';
import LockIcon from 'cccisd-icons/lock4';

const Tab = ({ currTab, mediatorProps, onClickTab, tabKey }) => {
    let locked = false;
    if (!mediatorProps[tabKey]) {
        tabKey = tabKey.replace(/_locked$/, '');
        if (!mediatorProps[tabKey]) {
            return null;
        }
        locked = true;
    }

    if (!mediatorProps[tabKey].toggle && !mediatorProps[tabKey].isExternalRegistration) {
        return null;
    }

    return (
        <button
            type="button"
            className={`btn btn-secondary ${currTab === tabKey ? 'active' : ''}`}
            onClick={() => {
                if (!locked) {
                    onClickTab(tabKey);
                }
            }}
            disabled={locked}
        >
            {mediatorProps[tabKey].tabName}
            {locked ? (
                <span>
                    &nbsp;&nbsp;
                    <LockIcon />
                </span>
            ) : null}
        </button>
    );
};

export default Tab;
